import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import type {SelectSize} from 'shells/select-picker-generic/select-picker-generic-creatable';
import type {Option} from 'shells/select-picker-generic/types';

import type {
    GetProducts as GetProductsQuery,
    GetProductsVariables as GetProductsQueryVariables,
} from 'nutshell-graphql-types';

import GET_PRODUCTS from '../../setup/products/graphql/queries/get-products.graphql';

import {GraphQLSelect} from './graphql-select';

const FIRST = 1000;

type Props = {
    onChange: (option: Option) => void;
    selectedId: string | null | undefined;
    size?: SelectSize;
    hideDivider?: boolean;
    placeholder?: string;
};

export function GraphQLSelectProducts(props: Props) {
    const {data, loading, refetch} = useQuery<GetProductsQuery, GetProductsQueryVariables>(
        GET_PRODUCTS,
        {
            variables: {
                first: FIRST,
            },
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    const products = data && data.products ? data.products.edges.map((edge) => edge.node) : [];

    const productOptions = products
        ? products.map((product) => ({
              label: product.name,
              value: product.id,
          }))
        : [];

    return (
        <GraphQLSelect
            isLoading={loading}
            placeholder={props.placeholder || 'Search products…'}
            models={productOptions}
            labelKey='label'
            valueKey='value'
            onChange={props.onChange}
            selectedId={props.selectedId}
            refetch={refetch}
            size={props.size}
            hideDivider={props.hideDivider}
        />
    );
}
